import { jwtDecode } from 'jwt-decode';
import type { Session } from '@ory/client';

const STUDENT_ACCESS_EMAILS = new Set([
  'fritjof.cavallin@allbinary.se',
  'samuel.olsson@allbinary.se',
]);

const normalizeEmail = (email: string): string => email.trim().toLowerCase();

interface StudentAccessInput {
  studentsDisabled?: boolean;
  email?: string;
}

export const isStudentAccessDisabled = ({
  studentsDisabled,
  email,
}: StudentAccessInput): boolean => {
  if (studentsDisabled !== true) {
    return false;
  }

  return (
    email === undefined || !STUDENT_ACCESS_EMAILS.has(normalizeEmail(email))
  );
};

export const emailFromSession = (session?: Session): string | undefined => {
  const traits = session?.identity?.traits;
  if (!traits || typeof traits !== 'object') {
    return undefined;
  }

  const email = (traits as { email?: unknown }).email;
  return typeof email === 'string' ? email : undefined;
};

export const emailFromAccessToken = (
  accessToken?: string,
): string | undefined => {
  if (!accessToken) {
    return undefined;
  }

  try {
    const { email } = jwtDecode<{ email?: string }>(accessToken);
    return email;
  } catch {
    return undefined;
  }
};
